import Image from 'next/legacy/image';

import type { WebinarPreviewDto } from '@/api/webinar';

import * as S from './WebinarRecommend.style';

type WebinarRecommendProps = {
  recommends: WebinarPreviewDto[];
};

const WebinarRecommend = ({ recommends }: WebinarRecommendProps) => {
  function getStrByCareer(career: string): string {
    if (career === 'developer') {
      return '개발자';
    }
    if (career === 'ceo') {
      return '대표';
    }
    return '';
  }
  return (
    <S.Container>
      <S.Title>함께 보면 좋은 웨비나</S.Title>
      {recommends.map((recommend: WebinarPreviewDto, index: number) => (
        <S.RecommendItem key={index} href={`/webinar/${recommend.title}`}>
          <S.RecommendInfo>
            <S.ThumbnailImgWrapper>
              <Image
                src={`${process.env.NEXT_PUBLIC_CDN_BASE_URL}/${recommend.thumbnail}`}
                layout='fill'
                alt='웨비나 썸네일'
              />
            </S.ThumbnailImgWrapper>
            <S.RecommendTextWrapper>
              <S.RecommendTitle>{recommend.video.title}</S.RecommendTitle>
              <S.RecommendLecture>
                {recommend.lecturer.name}{' '}
                {getStrByCareer(recommend.lecturer.career)}・&nbsp;
                {Math.floor(recommend.video.time / 60)}분
              </S.RecommendLecture>
            </S.RecommendTextWrapper>
          </S.RecommendInfo>
        </S.RecommendItem>
      ))}
    </S.Container>
  );
};
export default WebinarRecommend;
